module.exports = __webpack_public_path__ + "img/novo_canal_atendimento.458f306a.jpg";